<template>
    <div>
        <layout :top="true" :hasBottom="false">
            <div slot="head" v-show="!previewImg">
                <TopTabbar :hastitle="true" :title="info.goodsName" />
            </div>
            <div slot="content" class="con">
                <!-- <div class="content" v-show="!showDetails"> -->
                <div class="content">
                    <div class="left">
                        <img
                            src="https://img3a.gemtec.ltd/20211013165013.png"
                            alt=""
                            class="bgImg"
                        />

                        <div
                            class="info leftMark animated fadeInLeft"
                            @click="details"
                        >
                            <img
                                src="https://img3.gemtec.ltd/%E8%AF%A6%E6%83%85%402x.png"
                                alt=""
                            />
                            <p class="ipadfont">详情</p>
                            <div class="sharp" />
                        </div>

                        <div class="qrcode-wra" v-if="showCode">
                            <div id="qrcode" class="qrcode"></div>
                            <div class="qrcode-text">扫一扫体验</div>
                            <div class="qrcode-text">山河集小程序</div>
                        </div>

                        <img
                            class="logo"
                            :src="$store.state.v_loge"
                            alt=""
                            v-if="shop_id"
                        />

                        <img
                            class="logo"
                            src="@/assets/img/291b5ccba3708665eeecc427fafd6da.png"
                            v-else
                        />
                        <div>
                            <img
                                @click="zoom"
                                :src="activeImg"
                                alt=""
                                class="shop-img"
                                :class="
                                    this.previewImg ? 'shop-img-active' : ''
                                "
                            />
                        </div>
                        <div class="list-wrapper">
                            <div
                                v-for="(item, index) in thumbnailList"
                                :key="item.id"
                                class="item"
                                @click.stop="jumpTo(index)"
                            >
                                <img :src="item.file_path" alt="" />
                            </div>
                        </div>
                    </div>

                    <div class="right">
                        <div class="title-info">
                            <div class="name">
                                {{
                                    skuList[skuActive]
                                        ? skuList[skuActive].goods_name
                                        : ""
                                }}
                            </div>
                            <div class="material">
                                <span>产品编号:</span
                                >{{
                                    skuList[skuActive]
                                        ? skuList[skuActive].goods_number
                                        : ""
                                }}
                            </div>
                            <div class="material">
                                <span>(金)材质:</span
                                >{{
                                    skuList[skuActive]
                                        ? skuList[skuActive].sku[0].material
                                        : ""
                                }}
                                <div style="display: inline" v-if="goods_size">
                                    |
                                    <span>尺寸:</span>
                                    {{
                                        skuList[skuActive]
                                            ? skuList[skuActive].sku[0]
                                                  .goods_size
                                            : ""
                                    }}
                                </div>
                            </div>
                            <!-- <div v-if="userType">
                                <div
                                    class="material"
                                    v-if="token && goods_sell_wage != '0.00'"
                                >
                                    <span>销售工费（g）:</span
                                    >{{
                                        skuList[skuActive]
                                            ? skuList[skuActive].sku[0]
                                                  .goods_sell_wage
                                            : ""
                                    }}
                                </div>
                                <div
                                    class="material"
                                    v-if="
                                        token && goods_add_sell_wage != '0.00'
                                    "
                                >
                                    <span>销售附加工费（件）:</span
                                    >{{
                                        skuList[skuActive]
                                            ? skuList[skuActive].sku[0]
                                                  .goods_add_sell_wage
                                            : ""
                                    }}
                                </div>
                            </div> -->
                            <div class="goods_price" v-if="!token">
                                <span>具体价格请咨询客服</span>
                            </div>
                        </div>

                        <div class="sku-wrapper">
                            <div class="sku-title">规格</div>
                            <div class="sku-list">
                                <div
                                    v-for="(item, index) in skuList"
                                    :key="index"
                                    class="sku-item"
                                    :class="{ active: index === skuActive }"
                                    @click="switchSku(index)"
                                >
                                    重量{{ item.sku[0].goods_weight }}g |
                                    {{ item.sku[0].material }}
                                </div>
                            </div>
                        </div>

                        <div class="stepper-wrapper" v-if="token">
                            <div class="stepper-name">购买数量</div>
                            <van-stepper v-model="numValue" />
                        </div>

                        <div class="btn-wrapper" v-if="token">
                            <div class="btn" @click="addCard">加入购物车</div>
                            <div class="btn" @click="OrderShow">立即下单</div>
                        </div>
                    </div>
                </div>
                <transition name="details-fade" mode="out-in">
                    <div class="details" v-show="showDetails">
                        <div
                            class="close ets leftMark animated fadeInLeft"
                            @click="closure"
                            style="position: absolute"
                        >
                            <img
                                src="https://img3.gemtec.ltd/%E5%85%B3%E9%97%AD%402x.png"
                            />
                            <p class="ipadfont">关闭</p>
                        </div>

                        <div class="goodInfo" ref="goodInfo">
                            <div>
                                <div
                                    class="content_text"
                                    ref="content_text"
                                    v-html="
                                        skuList[skuActive]
                                            ? skuList[skuActive].content
                                            : ''
                                    "
                                    @click="showImg($event)"
                                ></div>
                            </div>
                        </div>
                    </div>
                </transition>
                <div :class="showDetails ? 'box' : ''"></div>
                <!-- <swiper :options="swiperOptionh" ref="swiperOuter">
                    <swiper-slide
                        :style="'position: relative;'"
                        class="stop-swiping"
                    >
                        <swiper
                            v-if="info.imgList.length > 0"
                            :options="swiperOption"
                            ref="swiperOption"
                            class="swiperWrap"
                        >
                            <swiper-slide
                                v-for="(item, index) in info.imgList"
                                :key="index"
                                class="swiperItem"
                            >
                                <img @click="showInfo" :src="item.file_path" />
                            </swiper-slide>
                            <div class="pagWrap" slot="pagination"></div>
                        </swiper>
                        <div class="title">
                            {{ info.goodsName }} | {{ info.goodWight }}克
                        </div>

                     
                        <div
                            class="dts leftMark animated fadeInLeft"
                            @click="showInfo"
                        >
                            <img
                                src="https://img3.gemtec.ltd/%E8%AF%A6%E6%83%85%402x.png"
                                alt=""
                            />
                            <p class="ipadfont">详情</p>
                            <div class="sharp" />
                        </div>
                     
                    </swiper-slide>

                    <swiper-slide id="showswiper" class="stop-swiping">
                        <div
                            class="close ets leftMark animated fadeInLeft"
                            @click="backSlidePrev"
                            style="position: absolute"
                        >
                            <img
                                src="https://img3.gemtec.ltd/%E5%85%B3%E9%97%AD%402x.png"
                            />
                            <p class="ipadfont">关闭</p>
                        </div>
                    
                        <div class="goodInfo" ref="goodInfo">
                            <div>
                                <div class="content_title">
                                    {{ info.goodsName }}
                                </div>
                                <div
                                    class="content_text"
                                    ref="content_text"
                                    v-html="info.goodsContent"
                                    @click="showImg($event)"
                                ></div>
                            </div>
                        </div>
                    </swiper-slide>
                </swiper> -->
            </div>
        </layout>
        <van-popup v-model="show" @open="popOpen()" style="border-radius: 4px">
            <div>
                <van-loading
                    type="spinner"
                    v-if="!already"
                    style="
                        display: block;
                        height: 41px;
                        width: 41px;
                        margin: 0px auto;
                    "
                />
            </div>
            <div class="qrcode">
                <img :src="info.qrCode" />
            </div>
            <p class="wxsys">微信扫一扫</p>
        </van-popup>

        <van-popup
            v-model="isOrderShow"
            :close-on-click-overlay="false"
            style="z-index: 999"
            :closeable="true"
        >
            <div class="order-wrapper">
                <div class="pop-title">
                    <!-- <i class="iconfont iconguanbi3" @click="isOrderShow = false"></i> -->
                    确认订单
                </div>
                <div class="pop-box">
                    <div class="pop-content">
                        <img :src="activeImg" alt="" class="pop-img" />
                        <div class="pop-con">
                            <div class="name">
                                {{
                                    skuList[skuActive]
                                        ? skuList[skuActive].goods_name
                                        : ""
                                }}
                            </div>
                            <div class="material">
                                <span
                                    >产品编码:{{
                                        skuList[skuActive]
                                            ? skuList[skuActive].goods_number
                                            : ""
                                    }}</span
                                >
                            </div>
                            <div class="material">
                                <span
                                    >(金)材质:{{
                                        skuList[skuActive]
                                            ? skuList[skuActive].sku[0].material
                                            : ""
                                    }}</span
                                >
                                <div style="margin-top: 5px" v-if="goods_size">
                                    <span
                                        >尺寸:{{
                                            skuList[skuActive]
                                                ? skuList[skuActive].sku[0]
                                                      .goods_size
                                                : ""
                                        }}</span
                                    >
                                </div>
                            </div>
                            <span style="color: #747474"
                                >克重(g):{{
                                    skuList[skuActive]
                                        ? skuList[skuActive].sku[0].goods_weight
                                        : ""
                                }}</span
                            >

                            <!-- <div v-if="userType">
                                <div
                                    class="material"
                                    v-if="token && goods_sell_wage != '0.00'"
                                >
                                    <span
                                        >销售工费（g）:{{
                                            skuList[skuActive]
                                                ? skuList[skuActive].sku[0]
                                                      .goods_sell_wage
                                                : ""
                                        }}</span
                                    >
                                </div>
                                <div
                                    class="material"
                                    v-if="
                                        token && goods_add_sell_wage != '0.00'
                                    "
                                >
                                    <span
                                        >销售附加工费（件）:{{
                                            skuList[skuActive]
                                                ? skuList[skuActive].sku[0]
                                                      .goods_add_sell_wage
                                                : ""
                                        }}</span
                                    >
                                </div>
                            </div> -->
                            <!-- <div class="goods_price">
                            <span>￥</span
                            >{{
                                skuList[skuActive]
                                    ? skuList[skuActive].sku[0].goods_price
                                    : ""
                            }}
                        </div> -->
                        </div>
                    </div>
                    <div class="custom" v-if="Mobile">
                        <van-cell-group>
                            <van-field
                                :border="border"
                                v-model="lettering"
                                maxlength="8"
                                label="刻字要求"
                                placeholder="请输入刻字要求(8字内)"
                            />
                            <van-field
                                :border="border"
                                v-model="goods_remark"
                                :maxlength="50"
                                label="备注"
                                placeholder="请输入想备注的内容"
                            />
                            <van-field
                                :border="border"
                                v-model="customer_name"
                                label="客户姓名"
                                placeholder="请输入客户姓名"
                            />
                            <van-field
                                :border="border"
                                v-model="customer_phone"
                                type="number"
                                maxlength="11"
                                label="客户手机"
                                placeholder="请输入客户手机号"
                            />
                        </van-cell-group>
                    </div>
                </div>
                <!-- <div class="pop-input">
                    <van-field
                        :value="userMobile"
                        @focus="focusMobile"
                        label="客户手机"
                        type="tel"
                        placeholder="请输入客户手机"
                    />
                    <van-field
                        :value="userMoney"
                        @focus="focusPassword"
                        label="实际支付金额"
                        placeholder="请输入实际支付金额"
                    />
                </div> -->
                <div class="pop-down">
                    <!-- <div class="pop-price">
                        <span>金额: </span>
                        {{
                            skuList[skuActive]
                                ? skuList[skuActive].sku[0].goods_price
                                : ""
                        }}
                    </div> -->
                    <div class="pop-btn" @click="padOrder">确定下单</div>
                    <div class="pop-btn2" @click="confirmSign">
                        {{ isEmpty ? "已签名" : "签名" }}
                    </div>
                </div>
            </div>
        </van-popup>
        <div class="box2">
            <van-popup
                v-model="sign"
                :close-on-click-overlay="false"
                :round="true"
                @click-close-icon="test1"
            >
                <div class="container">
                    <VueSignaturePad
                        id="signature"
                        height="4.5rem"
                        ref="signaturePad"
                        :options="options"
                    />
                </div>
                <div class="buttons">
                    <div class="left">
                        <div
                            style="margin-right: 30px"
                            class="sconfirm"
                            @click="save"
                        >
                            确认
                        </div>
                        <div class="sconfirm" @click="cancel">取消</div>
                    </div>
                    <div class="sremove" @click="undo">清除</div>
                </div>
            </van-popup>
        </div>
        <van-number-keyboard
            title="输入手机号码"
            @input="onInput"
            @delete="deleteMobile"
            close-button-text="关闭"
            maxlength="11"
            :show="showMobileKey"
            @blur="showMobileKey = false"
            style="z-index: 99999"
        />
        <van-number-keyboard
            title="输入金额"
            @input="onInputPassword"
            @delete="deletePassword"
            close-button-text="关闭"
            :show="showPasswordKey"
            @blur="showPasswordKey = false"
        />
    </div>
</template>

<script>
import {
    sendGoodBrowseInfo,
    getdetail,
    getposter,
    getList,
    skuList,
    padOrder,
    addCard,
    shoppCarList,
    qiniuToken,
    getJumpSwitch,
code
} from "../../api/http.js";
import { getLocalStorage } from "@/utils/storage.js";
import "animate.css";
import { formatDate } from "../../assets/js/format.js";
import layout from "@/components/layout.vue";
import TopTabbar from "@/components/TopTabbar.vue";
import QRCode from "qrcodejs2";
import { constants } from "crypto";
import { ImagePreview, Toast } from "vant";
import store from "../../store";
import { animatejs } from "../../utils/animatejs.js";
import Vue from "vue";
Vue.use(ImagePreview);
Vue.use(Toast);
import { animateCSS } from "../../utils/animate.js";
import holographic from "../../components/holographic";
import Bscroll from "@better-scroll/core";
import { LatheGeometry } from "three";
import $ from "jquery";
export default {
    components: {
        layout,
        TopTabbar,
    },

    data() {
        return {
            token: "",
            userType: null,
            numValue: 1,
            thumbnailList: [],
            showDetails: false,
            isOrderShow: false,
            skuList: [],
            skuActive: 0,
            activeImg: "",
            showMobileKey: false,
            userMobile: "",

            showPasswordKey: false,
            userMoney: "",

            showCode: false,

            showswiper: false,
            show: false,
            imgshow: false,
            contentShow: false,
            info: {
                //数据
                goodsName: "",
                goodsPrice: "",
                goodsContent: "",
                activeImg: "",
                activeIndex: 0,
                goodWight: "",
                imgList: [],
                hasqrCode: false,
                qrCode: "",
                modelId: false,
                imgUrl: [],
                goods_video: "",
            },
            ContentImg: [], //
            already: false, //二维码是否生成完成
            swiperOptionh: {
                direction: "vertical",
                loop: false,
                autoplay: false,
                noSwiping: true,
                noSwipingClass: "stop-swiping",
            },
            swiperOptionText: {
                direction: "vertical",
                slidesPerView: "auto",
                mousewheel: true,
                freeMode: true,
            },
            swiperOption: {
                direction: "vertical",
                watchSlidesProgress: true,
                slidesPerView: "auto",
                centeredSlides: true,
                loop: false,
                loopedSlides: 5,
                autoplay: false,
                pagination: {
                    el: ".pagWrap",
                    bulletActiveClass: "DetailItemactive",
                    bulletClass: "DetailItem",
                    renderCustom: function (swiper, current, total) {
                        return '<span class="' + swiper + '"></span>';
                    },
                },
                on: {
                    progress: function (progress) {
                        for (let i = 0; i < this.slides.length; i++) {
                            let slide = this.slides.eq(i);
                            let slideProgress = this.slides[i].progress;
                            let modify = 1;
                            if (Math.abs(slideProgress) > 1) {
                                modify =
                                    (Math.abs(slideProgress) - 1) * 0.3 + 1;
                            }
                            let translate =
                                slideProgress *
                                    (((store.state.screenHeight - 44) * 0.95 -
                                        100) /
                                        102.4) +
                                "rem";
                            let scale = 1 - Math.abs(slideProgress) / 5;
                            let zIndex =
                                100 - Math.abs(Math.round(10 * slideProgress));

                            slide.transform(
                                "translateY(" -
                                    translate +
                                    ") scale(" +
                                    scale +
                                    ")"
                            );
                            slide.css("zIndex", zIndex);
                            slide.css("opacity", 1);
                            if (
                                Math.round(slideProgress) > 3 ||
                                Math.round(slideProgress) < -3
                            ) {
                                slide.css("opacity", 0);
                            }
                        }
                    },
                    setTransition: function (transition) {
                        for (let i = 0; i < this.slides.length; i++) {
                            let slide = this.slides.eq(i);
                            slide.transition(transition);
                        }
                    },
                },
            },
            Mobile: null,
            lettering: "",
            goods_remark: "",
            customer_name: "",
            customer_phone: "",
            border: false,
            toast1: null,
            toast2: null,
            goods_sell_wage: "0.00",
            goods_add_sell_wage: "0.00",
            goods_size: "",
            previewImg: false,
            sign: false,
            options: {
                penColor: "#000",
            },
            isEmpty: false,
            base: "",
            qiniu: "",
            domain: "",
            shop_id: getLocalStorage("shop_id"),
            goodBrowseInfo:{
                goods_id: 0, 
                click_time: 0, 
                view_duration: 0,
            }
        };
    },
    computed: {
        imgheight() {
            return ((this.$store.state.screenHeight - 45) * 0.95) / 102.4;
        },
        viewheight() {
            return this.$store.state.screenHeight - 45;
        },
        swiperOuter() {
            return this.$refs.swiperOuter.swiper;
        },
        showOrder() {
            let shop_id = getLocalStorage("shop_id");
            if (
                this.skuList[this.skuActive] &&
                Number(shop_id) === this.skuList[this.skuActive].sku[0].shop_id
            ) {
                return true;
            } else {
                return false;
            }
        },
    },
    created() {
        this.isMobile();
        this.token = localStorage.getItem("login_token");
        if (localStorage.getItem("user_type") == "wholesaler_user") {
            this.userType = false;
        } else {
            this.userType = true;
        }
        const ids = this.$route.query.id; //获取url地址栏中id的值
        this.init(ids);
        // touchScroll("foot");
        this.addhistory();
        window.ensureSharedWorkerPortStart("app");
    },
    mounted() {
        // animateCSS(".title", "fadeInRight");
        // animateCSS(".ewm", "fadeInLeft");
        const worker = window.ensureSharedWorker();
        worker.port.postMessage({
            source: "app",
            target: "holographic",
            type: "changeMode",
            mode: "video",
        });
        this.goodBrowseInfo.goods_id = this.$route.query.id
        this.goodBrowseInfo.click_time = Math.floor(Date.now() / 1000);
    },
    beforeDestroy(){
        this.sendGoodBrowseInfoToServe()
    },
    destroyed() {
        if (this.toast1) {
            this.toast1.clear();
        }
        if (this.toast2) {
            this.toast2.clear();
        }
    },
    methods: {
        sendGoodBrowseInfoToServe(){
            let {goods_id, click_time, view_duration} = this.goodBrowseInfo
            view_duration = Math.floor(Date.now() / 1000) - click_time
            let token = localStorage.getItem("login_token")
            if(goods_id){
                sendGoodBrowseInfo(goods_id, click_time, view_duration, token)
            }
            
        },
        cancel() {
            this.sign = false;
            this.isOrderShow = true;
        },
        undo() {
            const { data } = this.$refs.signaturePad.saveSignature();
            this.$refs.signaturePad.clearSignature();
            this.isEmpty = false;
            console.log(this.isEmpty);
            this.base = data;
        },
        save() {
            let token = localStorage.getItem("login_token");
            const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
            if (isEmpty) {
                Toast("请签名");
            } else {
                this.base = data;
                this.base = this.base.slice(this.base.indexOf(",") + 1); //处理base64
                //获取七牛token
                qiniuToken(token).then((res) => {
                    this.qiniu = res.data.token;
                    this.domain = res.data.domain;
                    let size = this.dataURLtoBlob(data).size;
                    var pic = this.base; //base64w
                    var url = `https://upload-z2.qiniup.com/putb64/${size}`;
                    var xhr = new XMLHttpRequest();
                    xhr.onreadystatechange = () => {
                        if (xhr.readyState == 4) {
                            let text = JSON.parse(xhr.responseText);
                            this.domain += `/${text.hash}`;
                            this.isEmpty = true;
                        }
                    };
                    xhr.open("POST", url, true);
                    xhr.setRequestHeader(
                        "Content-Type",
                        "application/octet-stream"
                    );
                    xhr.setRequestHeader(
                        "Authorization",
                        "UpToken " + this.qiniu
                    );
                    xhr.send(pic);
                });
                this.sign = false;
                this.isOrderShow = true;
            }
        },
        dataURLtoBlob(dataurl) {
            var arr = dataurl.split(","),
                mime = arr[0].match(/:(.*?);/)[1],
                bstr = atob(arr[1]),
                n = bstr.length,
                u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new Blob([u8arr], { type: mime });
        },
        confirmSign() {
            this.isOrderShow = false;
            this.sign = true;
            if (!this.Mobile) {
                this.$nextTick(() => {
                    $(".box2").children(".van-popup").css({
                        height: "4rem",
                        top: "54%",
                    });
                    $("#signature").css({
                        overflow: "hidden",
                        height: "3rem",
                    });
                });
            }
        },
        zoom() {
            this.previewImg = !this.previewImg;
            console.log(this.previewImg);
        },
        test1() {
            this.isOrderShow = true;
            this.sign = false;
        },
        //点击关闭
        closure() {
            this.showDetails = !this.showDetails;
        },
        //点击详情
        details() {
            this.showDetails = true;
        },
        isMobile() {
            if (screen.height == 1080 && screen.width == 1920) {
                return (this.Mobile = false); // PC端
            } else {
                return (this.Mobile = true); //移动端
            }
        },
        //返回上一级
        goback() {
            this.$router.go(-1);
            setTimeout(() => {
                this.$router.go(0);
            }, 100);
        },
        //切换显示swiper
        showswiperFn() {
            this.$router.push({
                path: "/detailVideo",
                query: {
                    videoPath: this.info.goods_screen.video_front_url,
                },
            });
        },
        showInfo() {
            this.swiperOuter.slideNext();
        },
        backSlidePrev() {
            this.swiperOuter.slidePrev();
        },
        popup() {
            // console.log(1);
            this.show = !this.show;
        },
        preview(os) {
            this.ino = 0;
            this.eno = 1;
            this.show = !this.show;
        },
        init(ids) {
            getdetail(ids).then((res) => {
                //page sortType  sortPrice  category_id  search  wxapp_id
                if (res.code == 1) {
                    let data = res.data.detail;
                    this.info.goodsName = data.goods_name;
                    this.info.goodsPrice = data.sku[0].goods_price;
                    this.info.goodsContent = data.content;
                    this.info.imgList = data.image;
                    this.info.activeImg = this.info.imgList[0].file_path;
                    this.info.goodWight = data.sku[0].goods_weight.toFixed(2);
                    this.info.modelId = data.model_id || false;
                    this.info.goods_video = data.goods_video;
                    this.info.goods_screen = data.goods_screen;
                    let imgReg = /<img.*?(?:>|\/>)/gi;
                    let srcReg = /src=[\'\"]?([^\'\"]*)[\'\"]?/i;
                    let arr = data.content.match(imgReg);
                    if (arr != null) {
                        for (let i = 0; i < arr.length; i++) {
                            let src = arr[i].match(srcReg);
                            this.ContentImg.push(src[1]);
                        }
                    }
                    for (let i in data.image) {

                        if(process.env.VUE_APP_ISAPP=='true'){
                            //图片本地化
                            window.electronAPI.isImgExisted(data.image[i].image_id+'.png',i)
                        
                            window.electronAPI.on('isImgExistedRes',(isExisted,itemIndex)=>{
                                if(isExisted=='existed'){
                                    let imgPath =  './models/modelImgs/' + data.image[itemIndex].image_id + '.png' 
                                    this.info.imgUrl.push(imgPath);
                                }
                            })
                            //let imgPath =  './models/modelImgs/' + data.image[i].id + '.png'
                            //this.info.imgUrl.push(imgPath);
                        }else{
                            this.info.imgUrl.push(data.image[i].file_path);
                        }
                    }

                    setTimeout(() => {
                        // this.$refs.shop_img.style.opacity = 1;
                        document.querySelector(".shop-img").style.opacity = 1;
                    }, 500);
                    setTimeout(() => {
                        document.querySelector(
                            ".list-wrapper"
                        ).style.opacity = 1;
                        document.querySelector(".logo").style.opacity = 1;
                        document.querySelector(".qrcode-wra").style.opacity = 1;
                    }, 1000);
                    setTimeout(() => {
                        document.querySelector(".right").style.right = 0;
                    }, 1500);

                    //sku列表
                    skuList(data.goods_number).then(async(respone) => {
                        this.skuList = respone.data.detail;
                        this.activeImg =
                            this.skuList[this.skuActive].image[0].file_path;

                        this.thumbnailList = this.skuList[this.skuActive].image;
                        if(process.env.VUE_APP_ISAPP=='true'){
                            // this.thumbnailList.forEach(item=>{
                            //     item.file_path = './models/modelImgs/' + item.id + '.png'
                            // })

                            this.thumbnailList.forEach((item,index)=>{
                                

                                window.electronAPI.isImgExisted(item.image_id+'.png',index)
                        
                                window.electronAPI.on('isImgExistedRes',(isExisted,itemIndex)=>{
                                    if(isExisted=='existed'){
                                        this.thumbnailList[itemIndex].file_path = './models/modelImgs/' + this.thumbnailList[itemIndex].image_id + '.png'
                                    }
                                })
                            })

                            this.activeImg = this.thumbnailList[0].file_path;;
                        }

                        let jumpSwitchRes = await getJumpSwitch()
                        let jumpToId  = 0
                        if(jumpSwitchRes.data.isStoreJump){
                            jumpToId = getLocalStorage("shop_id")||0
                        }
                     
                        if (
                            this.skuList[this.skuActive].sku[this.skuActive]
                                .goods_add_sell_wage
                        ) {
                            this.goods_add_sell_wage =
                                this.skuList[this.skuActive].sku[
                                    this.skuActive
                                ].goods_add_sell_wage;
                        }
                        if (
                            this.skuList[this.skuActive].sku[this.skuActive]
                                .goods_sell_wage
                        ) {
                            this.goods_sell_wage =
                                this.skuList[this.skuActive].sku[
                                    this.skuActive
                                ].goods_sell_wage;
                        }
                        if (
                            this.skuList[this.skuActive].sku[this.skuActive]
                                .goods_size
                        ) {
                            this.goods_size =
                                this.skuList[this.skuActive].sku[
                                    this.skuActive
                                ].goods_size;
                        }

                        this.showCode = this.$store.state.is_code_off == 0;
                        this.$nextTick(()=>{
                            document.getElementById("qrcode") && new QRCode(document.getElementById("qrcode"), {
                            text: `https://large.shanheji.com.cn/${jumpToId}_1?goods_id=${
                                this.skuList[this.skuActive].goods_id
                            }`,
                            width: 100,
                            height: 100,
                            colorDark: "#000000",
                            colorLight: "#ffffff",
                        });
                        })
                        //逻辑写到全息上面

                        //全息
                        const goods_screen = res.data.detail.goods_screen;
                        const worker = window.ensureSharedWorker();
                        switch (goods_screen.is_type_screen) {
                            case 1: //图片
                                worker.port.postMessage({
                                    source: "app",
                                    target: "holographic",
                                    type: "update",
                                    resType: goods_screen.is_type_screen,
                                    url: goods_screen.image.length
                                        ? goods_screen.image[0].file_path
                                        : respone.data.detail[0].image[0]
                                              .file_path,
                                });
                                break;
                            case 2: //单个视频
                                worker.port.postMessage({
                                    source: "app",
                                    target: "holographic",
                                    type: "update",
                                    resType: goods_screen.is_type_screen,
                                    url: goods_screen.video_front_url,
                                });
                                break;
                            case 3: //270度视频
                                worker.port.postMessage({
                                    source: "app",
                                    target: "holographic",
                                    type: "update",
                                    resType: goods_screen.is_type_screen,
                                    front_url: goods_screen.video_front_url,
                                    left_url: goods_screen.video_left_url,
                                    right_url: goods_screen.video_right_url,
                                });
                                break;
                            case 4: //360度视频
                                worker.port.postMessage({
                                    source: "app",
                                    target: "holographic",
                                    type: "update",
                                    resType: goods_screen.is_type_screen,
                                    front_url: goods_screen.video_front_url,
                                    left_url: goods_screen.video_left_url,
                                    right_url: goods_screen.video_right_url,
                                    back_url: goods_screen.video_back_url,
                                });
                                break;
                        }
                    });
                }
            });
        },
        jumpTo(index) {
            console.log(index);
            this.info.activeIndex = index;
            this.activeImg =
                this.skuList[this.skuActive].image[index].file_path;
        },
        JumpTD(id) {
            // console.log(2);
            // window.location.href = "https://m.p.gemtec.ltd/#/model-view/" + id;
            this.$router.push({
                name: "detailThree",
                query: {
                    modelId:
                        "https://img5.gemtec.ltd/editorTest_sceneGltf/11522335-6B24-4852-99F9-C7EA2E0BDE2F.glb",
                },
            });
        },
        popOpen() {
            if (!this.hasqrCode) {
                this.hasqrCode = !this.hasqrCode;
                const ids = this.$route.query.id;
                getposter(ids, 10002).then((res) => {
                    //page sortType  sortPrice  category_id  search  wxapp_id
                    let data = res.data;
                    if (data.code == 1) {
                        this.info.qrCode = data.data.qrcode;
                        this.already = !this.already;
                    } else {
                        this.hasqrCode = !this.hasqrCode;
                    }
                });
            }
        },
        openImg() {
            ImagePreview(this.info.imgUrl);
        },
        addhistory() {
            if (localStorage.getItem("history") == null) {
                let his = [
                    {
                        time: formatDate(new Date(), "yyyy-MM-dd"),
                        goods_id: this.$route.query.id,
                    },
                ];
                localStorage.setItem("history", JSON.stringify(his));
            } else {
                let temp = null;
                let his = JSON.parse(localStorage.getItem("history"));
                let goodsId = this.$route.query.id;
                if (goodsId == his[his.length - 1].goods_id) {
                    temp = true;
                }
                let compareHistory = his.some(function (his) {
                    if (temp) {
                        return (
                            his.time == formatDate(new Date(), "yyyy-MM-dd") &&
                            his.goods_id == goodsId
                        );
                    } else {
                    }
                });
                if (!compareHistory) {
                    his.push({
                        time: formatDate(new Date(), "yyyy-MM-dd"),
                        goods_id: this.$route.query.id,
                    });
                    localStorage.setItem("history", JSON.stringify(his));
                }
            }
        },
        showImg(e) {
            if (e.target.localName == "img") {
                ImagePreview(this.ContentImg);
            }
        },

        switchSku(index) {
            this.activeImg = this.skuList[index].image[0].file_path;
            this.thumbnailList = this.skuList[index].image;
            if(process.env.VUE_APP_ISAPP=='true'){
                // this.thumbnailList.forEach(item=>{
                //     item.file_path = './models/modelImgs/' + item.id + '.png'
                // })
                this.thumbnailList.forEach((item,index)=>{
                                
                    window.electronAPI.isImgExisted(item.image_id+'.png',index)
            
                    window.electronAPI.on('isImgExistedRes',(isExisted,itemIndex)=>{
                        if(isExisted=='existed'){
                            this.thumbnailList[itemIndex].file_path = './models/modelImgs/' + this.thumbnailList[itemIndex].image_id + '.png'
                        }
                    })
                })

                this.activeImg = this.thumbnailList[0].file_path;;
            }
            this.skuActive = index;
        },

        onInput(key) {
            if (this.userMobile.length > 10) {
                return;
            }
            let keys = String(key);
            this.userMobile = this.userMobile.concat(keys);
        },

        focusMobile() {
            document.activeElement.blur();
            this.showMobileKey = true;
        },

        deleteMobile() {
            if (this.userMobile) {
                let mobile = this.userMobile.slice(
                    0,
                    this.userMobile.length - 1
                );
                this.userMobile = mobile;
            }
        },

        onInputPassword(key) {
            let keys = String(key);
            this.userMoney = this.userMoney.concat(keys);
        },

        deletePassword() {
            if (this.userMoney) {
                let password = this.userMoney.slice(
                    0,
                    this.userMoney.length - 1
                );
                this.userMoney = password;
            }
        },

        focusPassword() {
            document.activeElement.blur();

            this.showPasswordKey = true;
        },

        padOrder() {
            let token = localStorage.getItem("login_token");
            if (!token) {
                this.$toast("请先登录");
                return;
            }
            let goods_id = this.skuList[this.skuActive].goods_id;
            let goods_sku_id = this.skuList[this.skuActive].sku[0].goods_sku_id;
            if (this.isEmpty) {
                padOrder(
                    token,
                    goods_id,
                    this.numValue,
                    this.goods_remark,
                    this.lettering,
                    this.customer_phone,
                    this.customer_name,
                    this.domain, //签名
                    goods_sku_id
                    
                ).then((res) => {
                    console.log(res);
                    if(res.code == 1){
                        this.toast2 = this.$toast("下单成功");
                    }else{
                        this.toast2 = this.$toast("下单失败");
                    }
                    this.isOrderShow = false;
                    this.isEmpty = false;
                });
            } else {
                Toast("请签名");
            }
        },

        OrderShow() {
            // if (!this.skuList[this.skuActive].sku[0].stock_num) {
            //     this.$toast("商品库存不足");
            //     return;
            // }
            this.isOrderShow = true;
        },

        addCard() {
            let token = localStorage.getItem("login_token");
            if (!token) {
                this.$toast("请先登录");
                return;
            }
           
            let goods_id = this.skuList[this.skuActive].goods_id;
            let goods_sku_id = this.skuList[this.skuActive].sku[0].goods_sku_id;
            // let goods_sku_id = 0;

            addCard(goods_id, this.numValue, goods_sku_id, token).then(
                (res) => {
                    shoppCarList(token).then((res) => {
                        this.$store.commit("cart", res.data.goods_list.length);
                        this.toast1 = this.$toast("加入购物车成功");
                    });
                }
            );
        },
    },
};
</script>
<style lang="scss" scoped>
$bottomHeight:115px;
.details-fade-enter,
.details-fade-leave-to {
    opacity: 0;
    transform: translateY(100%);
}
.details-fade-enter-active,
.details-fade-leave-active {
    transition: 0.5s;
}
.goodInfo::-webkit-scrollbar {
    display: none;
}
.box {
    position: absolute;
    top: 0;
    z-index: 9998;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
    transition: 0.5s;
}

.logo {
    transition: 0.5s;
    opacity: 0;
    position: absolute;
    bottom: 50px;
    right: 50px;
    z-index: 1000;
    width: 50px;
}
.logoV {
    transition: 0.5s;
    opacity: 0;
    position: absolute;
    bottom: 50px;
    right: 50px;
    z-index: 1000;
    width: 55px;
}
.close {
    position: fixed;
    margin-top: 42px;
    right: 0;
    margin-right: 40px;
}
/deep/.swiper-container {
    width: 100vw !important;
    height: 100vh;
    .swiperItem {
        width: 100vw !important;
        height: 100vh !important;
    }
}
/deep/.van-overlay {
    z-index: 99 !important;
}
/deep/.van-number-keyboard {
    z-index: 999 !important;
}
.order-wrapper {
    width: 40vw;
    height: 60vh;
    position: relative;
    padding-bottom: 70px;
    .pop-title {
        position: relative;
        height: 48px;
        line-height: 48px;
        text-align: center;
        background-color: #e6e6e6;
        font-size: 14px;
        .iconfont {
            position: absolute;
            top: 50%;
            right: 5%;
            transform: translateY(-50%);
        }
    }
    .pop-content {
        margin-bottom: 12px;
        width: 95%;
        display: flex;
        padding: 12px;
        border-bottom: 1px solid #c4c4c4;
        box-sizing: border-box;
        position: relative;
        left: 50%;
        transform: translateX(-50%);
        .pop-img {
            width: 120px;
            height: 120px;
        }
        .pop-con {
            margin-left: 12px;
            font-size: 12px;
            .name {
                margin-bottom: 10px;
            }
            .material {
                margin-bottom: 5px;

                span {
                    color: #747474;
                }
            }
            .goods_price {
                font-size: 16px;
                span {
                    font-size: 12px;
                }
            }
        }
    }
    .pop-input {
        margin-top: 10px;
        padding: 12px;
        /deep/.van-cell__value {
            background-color: #f7f8fa;
            height: 35px;
            line-height: 35px;
            padding-left: 5px;
        }
        /deep/.van-field__label {
            height: 35px;
            line-height: 35px;
        }
        /deep/.van-cell {
            padding: 0;
            margin-bottom: 5px;
        }
    }
    .pop-down {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 70px;
        background-color: #e6e6e6;
        .pop-price {
            position: absolute;
            top: 50%;
            left: 5%;
            transform: translateY(-50%);
            font-size: 16px;
            span {
                font-size: 12px;
            }
        }
        .pop-btn,
        .pop-btn2 {
            width: 40%;
            height: 44px;
            line-height: 44px;
            text-align: center;
            background: #222222;
            border-radius: 6px;
            position: absolute;
            top: 50%;
            left: 25%;
            transform: translate(-50%, -50%);
            font-size: 14px;
            color: #fff;
        }
        .pop-btn2 {
            left: 75%;
        }
    }
}
.con {
    position: relative;
    width: 100%;
    height: 100%;
    padding-top: 44px;
    box-sizing: border-box;
    bottom: 0px;
    position: fixed;
    overflow: hidden;
    .content {
        width: 100%;
        height: 100%;
        display: flex;
        .left {
            width: 70%;
            height: 100%;
            position: relative;
            .bgImg {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
            .info {
                position: absolute;
                left: -20px;
                top: 20px;
                z-index: 9997;
            }
            .qrcode-wra {
                transition: 0.5s;
                opacity: 0;
                display: flex;
                flex-direction: column;
                justify-content: center;
                position: absolute;
                right: 20px;
                top: 20px;
                z-index: 9998;
                align-items: center;
            }
            .qrcode {
                margin-bottom: 5px;
                padding: 2px;
                background-color: #fff;
            }
            .qrcode-text {
                font-size: 10px;
                text-align: center;
                color: #c9a864;
            }
            .shop-img {
                transition: 1s;
                opacity: 0;
                position: absolute;
                // top: 50%;
                // left: 50%;
                // transform: translate(-50%, -50%);
                width: 100%;
                height: 100%;
                object-fit: contain;
                z-index: 999;
            }
            .shop-img-active {
                transition: none !important;
                position: fixed;
                top: 0;
                z-index: 99999;
                background: #000;
            }

            .list-wrapper {
                transition: 0.5s;
                opacity: 0;
                position: absolute;
                left: 5%;

                bottom: 5%;
                display: flex;
                z-index: 999;
                .item {
                    width: 50px;
                    height: 50px;
                    border-radius: 6px;
                    margin-right: 10px;
                    background-color: #fff;
                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }
                }
            }
        }
        .right {
            transition: 0.5s;
            position: relative;
            right: -100%;
            background-color: #e8e8e8;
            width: 30%;
            height: 100%;
            .title-info {
                position: relative;
                left: 50%;
                margin-top: 2px;
                transform: translate(-50%);
                width: 98%;
                background-color: #fff;
                padding-top: 18px;
                padding-bottom: 18px;
                padding-left: 12px;
                box-sizing: border-box;
                font-size: 12px;
                font-weight: 600;
                .name {
                    margin-bottom: 10px;
                }
                .material {
                    margin-bottom: 17px;

                    span {
                        color: #747474;
                    }
                }
                .goods_price {
                    font-size: 16px;
                    span {
                        font-size: 12px;
                    }
                }
            }
            .sku-wrapper {
                position: relative;
                left: 50%;
                margin-top: 2px;
                transform: translate(-50%);
                width: 98%;
                background-color: #fff;
                padding-top: 18px;
                padding-bottom: 18px;
                box-sizing: border-box;
                .sku-title {
                    color: #201f26;
                    font-size: 14px;
                    padding-left: 10px;
                    margin-bottom: 20px;
                }
                .sku-list {
                    padding-left: 2px;
                    display: flex;
                    flex-wrap: wrap;
                    // height:calc(100% - #{$bottomHeight});
                    height: 100px;
                    box-sizing: border-box;
                    overflow-y: auto;
                    padding-bottom:#{$bottomHeight} ;
                    .sku-item {
                        width: 48%;
                        height: 28px;
                        line-height: 28px;
                        border: 1px solid #201f26;
                        border-radius: 5px;
                        text-align: center;
                        margin-right: 2px;
                        margin-bottom: 2px;
                        font-size: 12px;
                    }
                    .active {
                        background-color: #201f26;
                        color: #fff;
                    }
                }
            }

            .stepper-wrapper {
                position: absolute;
                left: 50%;
                bottom: 65px;
                transform: translate(-50%);
                width: 98%;
                background-color: #fff;
                height: 50px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 0 16px;
                box-sizing: border-box;
                .stepper-name {
                    font-size: 14px;
                    color: #222222;
                }
            }

            .btn-wrapper {
                position: absolute;
                left: 50%;
                bottom: 0;
                transform: translate(-50%);
                width: 98%;
                background-color: #fff;
                height: 60px;
                display: flex;
                justify-content: space-around;
                align-items: center;
                .btn {
                    width: 130px;
                    height: 30px;
                    line-height: 30px;
                    background-color: #222222;
                    border-radius: 6px;
                    color: #fff;
                    text-align: center;
                    font-size: 12px;
                }
            }
        }
    }
    .details {
        position: absolute;
        top: 44px;
        z-index: 9999;
        width: 100%;
        height: 100%;
        .goodInfo {
            margin: 0px auto;
            width: 70%;
            height: 100%;
            background-color: #fff;
            // background: url("../../assets/img/bg2.png");
            // background-size: 100% 100%;
            // padding: 20px 50px 60px 50px;
            box-sizing: border-box;
            overflow-y: scroll;
            // .content_title {
            //   // padding: 40px 0px;
            //   border-bottom: 1px solid #c9a864;
            //   height: 26px;
            //   line-height: 26px;
            //   text-align: center;
            // }
            .content_text {
                // height: calc(100% - 116px);
                text-align: center;
                overflow: hidden;
                -webkit-overflow-scrolling: touch;
                margin-top: 10px;
                img {
                    width: 100%;
                }
            }
        }
    }
    .bgImg {
        position: absolute;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        object-fit: cover;
    }
    .swiperWrap {
        margin-top: 0px;
        .swiperItem {
            img {
                position: relative;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -58%);
                width: 90%;
                height: 100%;
                object-fit: contain;
                //    background-color: #000000;
            }
        }
    }
    .title {
        position: fixed;
        right: 0px;
        top: 20px;
        z-index: 200;
        color: #e7e7e7;
        // line-height: 15px;
        font-size: 10px;
        // padding: 20px 17px 20px 20px;
        width: 180px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        background: url("https://img3.gemtec.ltd/20210922164837.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
        //  background-color: #000000;
        .sharpRight {
            position: absolute;
            display: none;
            width: 0px;
            height: 0px;
            line-height: 0px; /*为了防止ie下出现题型*/
            border-top: 31.5px solid transparent;
            border-right: 31.5px solid #41403f;
            border-bottom: 31.5px solid transparent;
            right: 100%;
            top: 0px;
        }
    }
}
// .qrcode {
//     margin: 10px;
//     border-radius: 4px;
//     background: #fff;
//     width: 200px;
//     height: 200px;
//     overflow: hidden;
//     position: relative;
//     img {
//         width: 1000px;
//         position: absolute;
//         left: -753px;
//         top: -1213px;
//     }
// }

.wxsys {
    font-size: 14px;
    text-align: center;
    margin: 0px;
    padding-bottom: 10px;
}
.leftMark {
    width: 200px;
    // background: #41403f;
    text-align: center;
    z-index: 999;
    img {
        width: 45px;
        height: 45px;
        border-radius: 50%;
        // border: 2px solid #FFF1D8;
        // opacity: 0.8;
    }
    .ipadfont {
        margin-top: 9px;
        font-size: 12px;
        font-weight: 400;
        color: #fff1d8;
        line-height: 18px;
    }
    .sharp {
        position: absolute;
        width: 0px;
        height: 0px;
        line-height: 0px; /*为了防止ie下出现题型*/
        border-top: 33px solid transparent;
        // border-left: 33px solid #41403f;
        border-bottom: 33px solid transparent;
        left: 100%;
        top: 0px;
    }
}
.close {
    width: 45px;
    height: 45px;
}
.ets {
    right: 40px;
    top: 10px;
}
.dts {
    left: 0px;
    top: 40px;
}
.holo {
    left: 0px;
    top: 180px;
}
.three {
    left: 0px;
    top: 320px;
}
.ewm {
    left: 0px;
    top: 80px;
}
@keyframes scrollToUp {
    0% {
        transform: translateY(0px);
    }
    25% {
        transform: translateY(-5px);
    }
    50% {
        transform: translateY(0px);
    }
    75% {
        transform: translateY(-5px);
    }
    100% {
        transform: translateY(0px);
    }
}
.upTips {
    position: absolute;
    width: 100px;
    left: 50%;
    transform: translateY(50%);
    z-index: 8;
    .up {
        display: block;
        margin: 0px auto;
        width: 16px;
        height: 16px;
        animation: scrollToUp 5s linear infinite;
        font-size: 12px;
        color: #fff;
    }
    p {
        display: block;
        margin: 0px;
        font-size: 12px;
        color: #fff;
        text-align: center;
    }
}
.goodInfo {
    margin: 0px auto;
    width: 70%;
    height: 100%;
    background-color: #fff;
    // background: url("../../assets/img/bg2.png");
    // background-size: 100% 100%;
    // padding: 20px 50px 60px 50px;
    box-sizing: border-box;
    overflow-y: scroll;
    .content_title {
        padding: 20px 0px;
        border-bottom: 1px solid #000;
        font-size: 16px;
        height: 26px;
        line-height: 26px;
        text-align: center;
        color: #000;
    }
    .content_text {
        // height: calc(100% - 116px);
        text-align: center;
        overflow: hidden;
        -webkit-overflow-scrolling: touch;
        margin-top: 10px;
        img {
            width: 100%;
        }
    }
}
</style>
<style lang="scss">
.box2 .van-popup {
    width: 1000px;
    height: 550px;
    box-sizing: border-box;
    padding: 20px 20px 0;
    display: flex;
    flex-direction: column;
    #signature {
        // width: auto !important;
        // height: 450px !important;
        // border: 3px solid #000;
        background: #eee;

        // margin-bottom: 15px;
        // margin: 30px auto;
    }
    .buttons {
        display: flex;
        flex: 1;
        justify-content: space-around;
        align-items: center;
        .left {
            display: flex;
        }
        .sconfirm,
        .sremove {
            font-size: 15px;
            width: 128px;
            height: 40px;
            line-height: 40px;
            text-align: center;
            background-color: #090808;
            color: #fff;
            border-radius: 5px;
        }
        .sremove {
            position: absolute;
            right: 20px;
            width: 80px;
            height: 40px;
        }
    }
}
.van-popup__close-icon {
    color: #222 !important;
}
.pop-title {
}
.van-hairline--top-bottom::after {
    border-width: 0 !important;
}
.pop-box {
    height: 100%;
    overflow-y: auto;
    .custom {
        height: 240px;
        .van-cell {
            padding: 0 !important;
            font-size: 14px;
            .van-field__label {
                // max-width: 57px;
                text-align: right;
                line-height: 38px;
                margin: 0 8px 7px 0px;
            }
            .van-cell__value {
                max-width: 270px;
                height: 38px;
                background: #f1f1f1;
                input {
                    font-size: 14px;
                    line-height: 38px;
                    text-indent: 18px;
                }
            }
        }
    }
}

.holopage {
    // border: 1px solid red;
    .hptop {
        display: flex;
        justify-content: space-between;
        .hptop-left {
            text-align: center;
            margin-top: 33px;
            margin-left: 40px;
            img {
                width: 61px;
                height: 57px;
                background: #1c0f08;
                border-radius: 50%;
            }
            p {
                margin-top: 9px;
                font-size: 16px;
                font-weight: 400;
                color: #fff1d8;
                line-height: 18px;
            }
        }
        .hptop-right {
            text-align: center;
            margin-top: 33px;
            margin-right: 40px;
            img {
                width: 61px;
                height: 57px;
                background: #1c0f08;
                border-radius: 50%;
            }
            p {
                margin-top: 9px;
                font-size: 16px;
                font-weight: 400;
                color: #fff1d8;
                line-height: 18px;
            }
        }
    }
    #hpbottom {
        width: 340px;
        height: 483px;
        background-color: #4d3c22;
        // border: 1px solid red;
        box-sizing: border-box;
        margin: 0 auto;
        overflow: hidden;
    }
}
.pagWrap {
    right: 10px;
    transform: translate3d(0, -50%, 0);
    top: 50%;
    position: absolute;
    text-align: center;
    -webkit-transition: 0.3s opacity;
    -o-transition: 0.3s opacity;
    transition: 0.3s opacity;
    z-index: 10;
    bottom: initial !important;
    left: initial !important;
    width: initial !important;
}
.DetailItem {
    border-radius: 100%;
    background: #fff;
    opacity: 0.7;
    width: 8px;
    height: 8px;
    margin: 10px 0;
    display: block;
    line-height: 26px;
}
.DetailItemactive {
    background: #c9a864;
    opacity: 1;
}
.content_text img {
    max-width: 100%;
}
.content_text p {
    color: #c9a864;
    font-size: 14px;
}
.content_text .swiper-container {
    height: 100%;
}
.content_text .text {
    height: auto !important;
}
::-webkit-scrollbar {
       width: 0px;
 }
</style>
